import { render, staticRenderFns } from "./QTable.vue?vue&type=template&id=51583952"
import script from "./QTable.vue?vue&type=script&lang=js"
export * from "./QTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./QTable.vue?vue&type=custom&index=0&blockType=i18n&locale=ru&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dem/Go/src/github.com/demget/quadroclub/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('51583952', component.options)
    } else {
      api.reload('51583952', component.options)
    }
    module.hot.accept("./QTable.vue?vue&type=template&id=51583952", function () {
      api.rerender('51583952', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "site/src/components/table/QTable.vue"
export default component.exports